"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.install = void 0;
var spawn_1 = require("./../../helpers/spawn");
var types_1 = require("./types");
var util_1 = require("./util");
var logger_1 = __importDefault(require("../../helpers/logger"));
var app_paths_1 = require("../../helpers/app-paths");
var fs_1 = require("fs");
var toml_1 = __importDefault(require("@tauri-apps/toml"));
var inquirer_1 = __importDefault(require("inquirer"));
var log = logger_1.default('dependency:crates');
var dependencies = ['tauri'];
function readToml(tomlPath) {
    if (fs_1.existsSync(tomlPath)) {
        var manifest = fs_1.readFileSync(tomlPath).toString();
        return toml_1.default.parse(manifest);
    }
    return null;
}
function dependencyDefinition(version) {
    return { version: version.substring(0, version.lastIndexOf('.')) };
}
function manageDependencies(managementType) {
    return __awaiter(this, void 0, void 0, function () {
        var installedDeps, updatedDeps, result, manifest, lockPath, lock, _loop_1, _i, dependencies_1, dependency;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    installedDeps = [];
                    updatedDeps = [];
                    result = new Map();
                    manifest = readToml(app_paths_1.resolve.tauri('Cargo.toml'));
                    if (manifest === null) {
                        log('Cargo.toml not found. Skipping crates check...');
                        return [2 /*return*/, result];
                    }
                    lockPath = app_paths_1.resolve.tauri('Cargo.lock');
                    if (!fs_1.existsSync(lockPath)) {
                        spawn_1.spawnSync('cargo', ['generate-lockfile'], app_paths_1.tauriDir);
                    }
                    lock = readToml(lockPath);
                    _loop_1 = function (dependency) {
                        var lockPackages, manifestDep, currentVersion, latestVersion, latestVersion, inquired;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    lockPackages = lock
                                        ? lock.package.filter(function (pkg) { return pkg.name === dependency; })
                                        : [];
                                    manifestDep = manifest.dependencies[dependency];
                                    currentVersion = lockPackages.length === 1
                                        ? lockPackages[0].version
                                        : typeof manifestDep === 'string'
                                            ? manifestDep
                                            : manifestDep === null || manifestDep === void 0 ? void 0 : manifestDep.version;
                                    if (!(currentVersion === undefined)) return [3 /*break*/, 2];
                                    log("Installing " + dependency + "...");
                                    return [4 /*yield*/, util_1.getCrateLatestVersion(dependency)
                                        // eslint-disable-next-line security/detect-object-injection
                                    ];
                                case 1:
                                    latestVersion = _a.sent();
                                    // eslint-disable-next-line security/detect-object-injection
                                    manifest.dependencies[dependency] = dependencyDefinition(latestVersion);
                                    installedDeps.push(dependency);
                                    return [3 /*break*/, 8];
                                case 2:
                                    if (!(managementType === types_1.ManagementType.Update)) return [3 /*break*/, 7];
                                    return [4 /*yield*/, util_1.getCrateLatestVersion(dependency)];
                                case 3:
                                    latestVersion = _a.sent();
                                    if (!util_1.semverLt(currentVersion, latestVersion)) return [3 /*break*/, 5];
                                    return [4 /*yield*/, inquirer_1.default.prompt([
                                            {
                                                type: 'confirm',
                                                name: 'answer',
                                                message: "[CRATES] \"" + dependency + "\" latest version is " + latestVersion + ". Do you want to update?",
                                                default: false
                                            }
                                        ])
                                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-var-requires, @typescript-eslint/no-unsafe-member-access
                                    ];
                                case 4:
                                    inquired = _a.sent();
                                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-var-requires, @typescript-eslint/no-unsafe-member-access
                                    if (inquired.answer) {
                                        log("Updating " + dependency + "...");
                                        // eslint-disable-next-line security/detect-object-injection
                                        manifest.dependencies[dependency] = dependencyDefinition(latestVersion);
                                        updatedDeps.push(dependency);
                                    }
                                    return [3 /*break*/, 6];
                                case 5:
                                    log("\"" + dependency + "\" is up to date");
                                    _a.label = 6;
                                case 6: return [3 /*break*/, 8];
                                case 7:
                                    log("\"" + dependency + "\" is already installed");
                                    _a.label = 8;
                                case 8: return [2 /*return*/];
                            }
                        });
                    };
                    _i = 0, dependencies_1 = dependencies;
                    _a.label = 1;
                case 1:
                    if (!(_i < dependencies_1.length)) return [3 /*break*/, 4];
                    dependency = dependencies_1[_i];
                    return [5 /*yield**/, _loop_1(dependency)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4:
                    if (installedDeps.length || updatedDeps.length) {
                        fs_1.writeFileSync(app_paths_1.resolve.tauri('Cargo.toml'), toml_1.default.stringify(manifest));
                    }
                    if (updatedDeps.length) {
                        if (!fs_1.existsSync(app_paths_1.resolve.tauri('Cargo.lock'))) {
                            spawn_1.spawnSync('cargo', ['generate-lockfile'], app_paths_1.tauriDir);
                        }
                        spawn_1.spawnSync('cargo', __spreadArrays([
                            'update',
                            '--aggressive'
                        ], updatedDeps.reduce(function (initialValue, dep) { return __spreadArrays(initialValue, ['-p', dep]); }, [])), app_paths_1.tauriDir);
                    }
                    result.set(types_1.ManagementType.Install, installedDeps);
                    result.set(types_1.ManagementType.Update, updatedDeps);
                    return [2 /*return*/, result];
            }
        });
    });
}
function install() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, manageDependencies(types_1.ManagementType.Install)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.install = install;
function update() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, manageDependencies(types_1.ManagementType.Update)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.update = update;
